module.exports = __webpack_public_path__ + "static/main-84e889bf3f2e542f1ce427d4b13ace90.svg";